export default __webpack_public_path__ + "images/cy-70de54e68d8683969410788a726e35ec.svg";